/**
 * TopFade — single super-subtle light-gray gradient overlay that fades
 * from a whisper-quiet warm white at the top of the viewport down to
 * fully transparent over ~200px. Sits BEHIND the TopBar (z-index 0,
 * pointer-events:none) so it reads as ambient lift on the page chrome
 * without competing with content.
 *
 * Replaced the earlier WebGL Aurora effect (Aurora.tsx + Aurora.css)
 * which read too consumer-y for SceneForge's pro grayscale look. The
 * choice is deliberate:
 *   - fixed, top:0 — anchors to the viewport so scrolling content
 *     doesn't drag the gradient down
 *   - height: 200px — matches the user's "fade after ~200 pixels" ask
 *   - linear-gradient to-bottom from rgba(255,255,255,0.04) → 0 —
 *     ~4% opacity at the top is enough to read as "light coming from
 *     above" against the bg-zinc-950 page background without ever
 *     looking like a banner or branding panel
 *   - mix-blend-mode: screen — only ever brightens, never darkens, so
 *     even on dark surfaces (modals, video posters) the effect stays
 *     additive and never washes anything out
 */
export function TopFade() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-x-0 top-0 z-0 h-[200px]"
      style={{
        background:
          'linear-gradient(to bottom, rgba(255,255,255,0.04) 0%, rgba(255,255,255,0.02) 50%, rgba(255,255,255,0) 100%)',
        mixBlendMode: 'screen',
      }}
    />
  );
}
